// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v7.34.1
// source: content_filter_settings.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "content_filter_settings";

/** Main proto definition */
export interface ContentFilterSettings {
  /** the only supported content filter currently is "azure" */
  type: string;
  azureConfig: AzureContentFilter | undefined;
  updatedBy?: string | undefined;
  updatedAt?: Date | undefined;
  disabled?: boolean | undefined;
}

/** Helper proto definitions used to shape the main one */
export interface AzureContentFilterCategory {
  isActive: boolean;
  /** loose|medium|strict */
  precision: string;
}

export interface AzureContentFilter {
  violence: AzureContentFilterCategory | undefined;
  hate: AzureContentFilterCategory | undefined;
  sexual: AzureContentFilterCategory | undefined;
  selfHarm: AzureContentFilterCategory | undefined;
}

/** commands */
export interface ContentFilterSettingsUpdateContentFilterSettings {
  type?: string | undefined;
  azureConfig?: AzureContentFilter | undefined;
  disabled?: boolean | undefined;
}

function createBaseContentFilterSettings(): ContentFilterSettings {
  return { type: "", azureConfig: undefined, updatedBy: undefined, updatedAt: undefined, disabled: undefined };
}

export const ContentFilterSettings: MessageFns<ContentFilterSettings> = {
  encode(message: ContentFilterSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== "") {
      writer.uint32(10).string(message.type);
    }
    if (message.azureConfig !== undefined) {
      AzureContentFilter.encode(message.azureConfig, writer.uint32(18).fork()).join();
    }
    if (message.updatedBy !== undefined) {
      writer.uint32(26).string(message.updatedBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(34).fork()).join();
    }
    if (message.disabled !== undefined) {
      writer.uint32(40).bool(message.disabled);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ContentFilterSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseContentFilterSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.azureConfig = AzureContentFilter.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.disabled = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ContentFilterSettings {
    return {
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      azureConfig: isSet(object.azureConfig)
        ? AzureContentFilter.fromJSON(object.azureConfig)
        : isSet(object.azure_config)
        ? AzureContentFilter.fromJSON(object.azure_config)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      disabled: isSet(object.disabled) ? globalThis.Boolean(object.disabled) : undefined,
    };
  },

  toJSON(message: ContentFilterSettings): unknown {
    const obj: any = {};
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.azureConfig !== undefined) {
      obj.azureConfig = AzureContentFilter.toJSON(message.azureConfig);
    }
    if (message.updatedBy !== undefined) {
      obj.updatedBy = message.updatedBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.disabled !== undefined) {
      obj.disabled = message.disabled;
    }
    return obj;
  },

  create(base?: DeepPartial<ContentFilterSettings>): ContentFilterSettings {
    return ContentFilterSettings.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ContentFilterSettings>): ContentFilterSettings {
    const message = createBaseContentFilterSettings();
    message.type = object.type ?? "";
    message.azureConfig = (object.azureConfig !== undefined && object.azureConfig !== null)
      ? AzureContentFilter.fromPartial(object.azureConfig)
      : undefined;
    message.updatedBy = object.updatedBy ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.disabled = object.disabled ?? undefined;
    return message;
  },
};

function createBaseAzureContentFilterCategory(): AzureContentFilterCategory {
  return { isActive: false, precision: "" };
}

export const AzureContentFilterCategory: MessageFns<AzureContentFilterCategory> = {
  encode(message: AzureContentFilterCategory, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.isActive !== false) {
      writer.uint32(8).bool(message.isActive);
    }
    if (message.precision !== "") {
      writer.uint32(18).string(message.precision);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AzureContentFilterCategory {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAzureContentFilterCategory();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.isActive = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.precision = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AzureContentFilterCategory {
    return {
      isActive: isSet(object.isActive)
        ? globalThis.Boolean(object.isActive)
        : isSet(object.is_active)
        ? globalThis.Boolean(object.is_active)
        : false,
      precision: isSet(object.precision) ? globalThis.String(object.precision) : "",
    };
  },

  toJSON(message: AzureContentFilterCategory): unknown {
    const obj: any = {};
    if (message.isActive !== false) {
      obj.isActive = message.isActive;
    }
    if (message.precision !== "") {
      obj.precision = message.precision;
    }
    return obj;
  },

  create(base?: DeepPartial<AzureContentFilterCategory>): AzureContentFilterCategory {
    return AzureContentFilterCategory.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AzureContentFilterCategory>): AzureContentFilterCategory {
    const message = createBaseAzureContentFilterCategory();
    message.isActive = object.isActive ?? false;
    message.precision = object.precision ?? "";
    return message;
  },
};

function createBaseAzureContentFilter(): AzureContentFilter {
  return { violence: undefined, hate: undefined, sexual: undefined, selfHarm: undefined };
}

export const AzureContentFilter: MessageFns<AzureContentFilter> = {
  encode(message: AzureContentFilter, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.violence !== undefined) {
      AzureContentFilterCategory.encode(message.violence, writer.uint32(10).fork()).join();
    }
    if (message.hate !== undefined) {
      AzureContentFilterCategory.encode(message.hate, writer.uint32(18).fork()).join();
    }
    if (message.sexual !== undefined) {
      AzureContentFilterCategory.encode(message.sexual, writer.uint32(26).fork()).join();
    }
    if (message.selfHarm !== undefined) {
      AzureContentFilterCategory.encode(message.selfHarm, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AzureContentFilter {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAzureContentFilter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.violence = AzureContentFilterCategory.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.hate = AzureContentFilterCategory.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.sexual = AzureContentFilterCategory.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.selfHarm = AzureContentFilterCategory.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AzureContentFilter {
    return {
      violence: isSet(object.violence) ? AzureContentFilterCategory.fromJSON(object.violence) : undefined,
      hate: isSet(object.hate) ? AzureContentFilterCategory.fromJSON(object.hate) : undefined,
      sexual: isSet(object.sexual) ? AzureContentFilterCategory.fromJSON(object.sexual) : undefined,
      selfHarm: isSet(object.selfHarm)
        ? AzureContentFilterCategory.fromJSON(object.selfHarm)
        : isSet(object.self_harm)
        ? AzureContentFilterCategory.fromJSON(object.self_harm)
        : undefined,
    };
  },

  toJSON(message: AzureContentFilter): unknown {
    const obj: any = {};
    if (message.violence !== undefined) {
      obj.violence = AzureContentFilterCategory.toJSON(message.violence);
    }
    if (message.hate !== undefined) {
      obj.hate = AzureContentFilterCategory.toJSON(message.hate);
    }
    if (message.sexual !== undefined) {
      obj.sexual = AzureContentFilterCategory.toJSON(message.sexual);
    }
    if (message.selfHarm !== undefined) {
      obj.selfHarm = AzureContentFilterCategory.toJSON(message.selfHarm);
    }
    return obj;
  },

  create(base?: DeepPartial<AzureContentFilter>): AzureContentFilter {
    return AzureContentFilter.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AzureContentFilter>): AzureContentFilter {
    const message = createBaseAzureContentFilter();
    message.violence = (object.violence !== undefined && object.violence !== null)
      ? AzureContentFilterCategory.fromPartial(object.violence)
      : undefined;
    message.hate = (object.hate !== undefined && object.hate !== null)
      ? AzureContentFilterCategory.fromPartial(object.hate)
      : undefined;
    message.sexual = (object.sexual !== undefined && object.sexual !== null)
      ? AzureContentFilterCategory.fromPartial(object.sexual)
      : undefined;
    message.selfHarm = (object.selfHarm !== undefined && object.selfHarm !== null)
      ? AzureContentFilterCategory.fromPartial(object.selfHarm)
      : undefined;
    return message;
  },
};

function createBaseContentFilterSettingsUpdateContentFilterSettings(): ContentFilterSettingsUpdateContentFilterSettings {
  return { type: undefined, azureConfig: undefined, disabled: undefined };
}

export const ContentFilterSettingsUpdateContentFilterSettings: MessageFns<
  ContentFilterSettingsUpdateContentFilterSettings
> = {
  encode(
    message: ContentFilterSettingsUpdateContentFilterSettings,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.type !== undefined) {
      writer.uint32(10).string(message.type);
    }
    if (message.azureConfig !== undefined) {
      AzureContentFilter.encode(message.azureConfig, writer.uint32(18).fork()).join();
    }
    if (message.disabled !== undefined) {
      writer.uint32(24).bool(message.disabled);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ContentFilterSettingsUpdateContentFilterSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseContentFilterSettingsUpdateContentFilterSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.azureConfig = AzureContentFilter.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.disabled = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ContentFilterSettingsUpdateContentFilterSettings {
    return {
      type: isSet(object.type) ? globalThis.String(object.type) : undefined,
      azureConfig: isSet(object.azureConfig)
        ? AzureContentFilter.fromJSON(object.azureConfig)
        : isSet(object.azure_config)
        ? AzureContentFilter.fromJSON(object.azure_config)
        : undefined,
      disabled: isSet(object.disabled) ? globalThis.Boolean(object.disabled) : undefined,
    };
  },

  toJSON(message: ContentFilterSettingsUpdateContentFilterSettings): unknown {
    const obj: any = {};
    if (message.type !== undefined) {
      obj.type = message.type;
    }
    if (message.azureConfig !== undefined) {
      obj.azureConfig = AzureContentFilter.toJSON(message.azureConfig);
    }
    if (message.disabled !== undefined) {
      obj.disabled = message.disabled;
    }
    return obj;
  },

  create(
    base?: DeepPartial<ContentFilterSettingsUpdateContentFilterSettings>,
  ): ContentFilterSettingsUpdateContentFilterSettings {
    return ContentFilterSettingsUpdateContentFilterSettings.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<ContentFilterSettingsUpdateContentFilterSettings>,
  ): ContentFilterSettingsUpdateContentFilterSettings {
    const message = createBaseContentFilterSettingsUpdateContentFilterSettings();
    message.type = object.type ?? undefined;
    message.azureConfig = (object.azureConfig !== undefined && object.azureConfig !== null)
      ? AzureContentFilter.fromPartial(object.azureConfig)
      : undefined;
    message.disabled = object.disabled ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
